export const listAll = state => state.plans.all.data;
export const isLoadingAll = state => state.plans.all.loading;